import { Form, FormProps } from "@/components/form";
import { z } from "zod/v4";

export const depositoFormSchema = z.object({
    nombre: z.string().nonempty("Este campo es requerido")
})

export default function DepositoForm({
    form,
    ...props
}: FormProps<z.infer<typeof depositoFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Form.TextField name="nombre" label="Nombre" />
        <Form.SubmitButton>Guardar</Form.SubmitButton>
    </Form>
}
